import React, { useEffect, useState } from "react";
import axios from "axios";
import "./RewardScreen.css";
import { useNavigate } from "react-router-dom";

import headerImage from "../../assets/images/game-supergirls/TamhaRak_Poster.jpg";
import biggy from "../../assets/images/game-supergirls/Sticker-Thx.png";
import bigpointReward from "../../assets/images/game-supergirls/Big-Point-Card.png";

import { useLiffProfile } from "../../context/LiffProfileContext";
import api from "./api/axios";

const RewardScreen = ({ result, lineUserId }) => {
  const navigate = useNavigate();

  const correct = result.correct;
  const reward = result.reward;
  const isWinner = correct === true;
  const isLoser = correct === false;

  const DRAMA_URL = "https://www.one31.net/shows/detail/590";

  const { authToken, userId } = useLiffProfile();
  const [hasBigPoint, setHasBigPoint] = useState(false);
  const [bigpointId, setBigpointId] = useState("");
  const [checkingUser, setCheckingUser] = useState(true);

  const [loading, setLoading] = useState(false); // กัน double-click
  const [errorMessage, setErrorMessage] = useState(""); // popup message

  const API_URL = process.env.REACT_APP_API_URL;
  const CLIENT_AUTH = process.env.REACT_APP_CLIENT_AUTH;

  // ------------------------------------------------
  // STEP 1 : Load User → ตรวจว่ามี BigPoint หรือไม่
  // ------------------------------------------------
  useEffect(() => {
    const checkUserData = async () => {
      if (!authToken || !userId) return;

      try {
        const response = await axios.get(`${API_URL}/api/users/current`, {
          headers: {
            Authorization: `Bearer ${authToken}`,
            "X-Client-Auth": CLIENT_AUTH,
            "x-user-id": userId,
            "Accept-Language": "TH",
          },
        });

        const userData = response.data?.data;

        if (
          userData?.bigCardNumber &&
          userData.bigCardNumber.toLowerCase() !== "guest"
        ) {
          setHasBigPoint(true);
          setBigpointId(userData.bigCardNumber);
        } else {
          setHasBigPoint(false);
        }
      } catch (error) {
        console.error("Check user error:", error);
        setHasBigPoint(false);
      } finally {
        setCheckingUser(false);
      }
    };

    checkUserData();
  }, [authToken, userId, API_URL, CLIENT_AUTH]);

  // ---------------------------------------------------------
  // STEP 2 : Claim reward (พร้อมกัน Double-click + Error popup)
  // ---------------------------------------------------------
  const linkAndClaimReward = async () => {
    if (loading) return;
    setLoading(true);

    try {
      const rewardId = reward?.rewardId || reward?.id;

      await api.post("/game-bigpoint/link", {
        lineId: lineUserId,
        bigpointId: bigpointId,
      });

      const res = await api.post("/game-rewards/claim", {
        lineId: lineUserId,
        bigpointId: bigpointId,
        rewardId,
      });

      navigate("/game/rewards");
    } catch (err) {
      console.error("CLAIM ERROR:", err);

      // รองรับหลายรูปแบบจาก backend
      const backendError =
        err?.response?.data?.error ||
        err?.response?.data?.message ||
        err?.message;

      // Case: BigPoint ถูกผูกกับ Line ID อื่น
      if (
        backendError === "BIGPOINT_IN_USE_BY_OTHER_PLAYER" ||
        backendError?.includes("ใช้กับ player อื่น") ||
        backendError?.includes("Line ID อื่น")
      ) {
        setErrorMessage(
          "BigPoint นี้ถูกเชื่อมต่อกับ LINE ID อื่น กรุณาตรวจสอบหรือใช้ BigPoint ของคุณเอง"
        );
        setLoading(false);
        return;
      }

      // default case
      setErrorMessage(
        backendError || "เกิดข้อผิดพลาดในการรับรางวัล กรุณาลองใหม่อีกครั้ง"
      );
    }

    setLoading(false);
  };

  // ---------------------------------------------------------
  // UI Logic
  // ---------------------------------------------------------

  let title = "";
  let mainImage = biggy;
  let buttonText = "";
  let buttonAction = () => {};
  let disabled = false;

  if (isLoser) {
    title = `วันนี้ยังตอบไม่ถูก!<br/>อาจจะยังต้องทำการบ้านเพิ่มเติมสัปดาห์หน้ามาเล่นกันใหม่`;
    mainImage = biggy;
    buttonText = "ดูละครย้อนหลัง";
    buttonAction = () => (window.location.href = DRAMA_URL);
  }

  if (isWinner) {
    title = `ยินดีด้วย!<br/>คุณได้รับ ${
      reward?.point || 0
    } พอยต์ อย่าลืมไปใช้พอยต์รับความคุ้มได้ที่บิ๊กซีทุกสาขา`;
    mainImage = bigpointReward;

    if (checkingUser) {
      buttonText = "กำลังตรวจสอบข้อมูล...";
      disabled = true;
    } else {
      if (hasBigPoint) {
        buttonText = loading ? "กำลังทำรายการ..." : "รับรางวัล";
        buttonAction = linkAndClaimReward;
      } else {
        buttonText = "สมัครสมาชิกเพื่อรับสิทธิ์";
        buttonAction = () => (window.location.href = "/register");
      }
    }
  }

  return (
    <div className="quiz-container">
      <img src={headerImage} alt="header" className="quiz-header-image" />

      <h2
        className="reward-feedback-title"
        dangerouslySetInnerHTML={{ __html: title }}
      ></h2>

      <img src={mainImage} alt="Reward" className="reward-card-image" />

      <div className="reward-button-wrapper">
        <button
          className="btn-border-3d flex items-center justify-center gap-2"
          disabled={disabled || loading}
          style={{ opacity: disabled || loading ? 0.5 : 1 }}
          onClick={buttonAction}
        >
          {buttonText}
        </button>
      </div>

      {isWinner && !checkingUser && !hasBigPoint && (
        <div className="text-center mt-4 text-red-600 font-medium">
          <p>รางวัลมีอายุ 48 ชม.</p>
          <p>หากไม่สมัครสมาชิกภายในเวลาที่กำหนด ถือว่าสละสิทธิ์</p>
        </div>
      )}

      {/* ---------------- POPUP ERROR ---------------- */}
      {errorMessage && (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50">
          <div className="bg-white rounded-2xl p-6 w-10/12 max-w-sm text-center shadow-lg">
            <h3 className="text-xl font-bold text-red-600 mb-3">
              ไม่สามารถรับรางวัลได้
            </h3>
            <p className="text-gray-700">{errorMessage}</p>
            <button
              className="btn-border-3d mt-4 px-6 py-2"
              onClick={() => setErrorMessage("")}
            >
              ปิด
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default RewardScreen;
